<ng-container *ngIf="isTranslationDone && translationsArray.length">
<ng-container *ngIf="content | customTranslation: translationsArray; ">

    <section class="legal-page-container" [innerHTML]="content | customTranslation: translationsArray">
    
    </section>
    </ng-container>
    <ng-container *ngIf="isNotFound">
        <app-no-route></app-no-route>
    </ng-container>
</ng-container>